import { render, staticRenderFns } from "./SettingsEmailsTemplates.vue?vue&type=template&id=0cbf3b94&scoped=true&"
import script from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEmailsTemplates.vue?vue&type=style&index=0&id=0cbf3b94&prod&lang=scss&"
import style1 from "./SettingsEmailsTemplates.vue?vue&type=style&index=1&id=0cbf3b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf3b94",
  null
  
)

export default component.exports